import React from 'react'
import { CategoriaNode } from '@gql/graphql'
import { useTrans } from 'hooks'
import { WContainer } from '@components/atoms'
import { ListingHead, Page, TextSection } from 'components/organisms'
import styles from './ProdottiListingHubTemplate.module.sass'
import { CategoriaHubCard } from '@components/molecules'

interface Props {
  pagina?: any
  categoria?: CategoriaNode
}

const ProdottiListingHubTemplate = (props: Props) => {
  const { pagina = {}, categoria = undefined } = props

  const testoSeoItem = {
    name: categoria.sottoTitolo,
    description: categoria.guidaDettagliata,
  }

  const isAttivita = categoria.alias?.toLowerCase()?.includes('attività')

  return (
    <Page pagina={pagina} item={categoria} className={`${styles.root}`}>
      <main className={styles.main}>
        <ListingHead
          pagina={{
            ...pagina,
            titolo: categoria.nome,
            descrizione: categoria.guidaBreve,
          }}
        />
        {!!categoria?.children?.length && (
          <div className={styles.list}>
            <WContainer>
              <div className={styles.listLayout}>
                {categoria?.children.map((x) => (
                  <CategoriaHubCard
                    categoria={{ ...x, previewImage: isAttivita ? null : x.previewImage }}
                    key={x.pk}
                  />
                ))}
              </div>
            </WContainer>
          </div>
        )}
        <TextSection item={testoSeoItem} size="sm" align="left" />
      </main>
    </Page>
  )
}

export default ProdottiListingHubTemplate
